import { push } from "connected-react-router";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { applicationTypeFromLicenceSubType } from "../../../redux/slice/applicationsUtils";
import { Button, ErrorWithString } from "../../../components/RegularComponents";
import TopNavigationBar from "../../TopNavigationBar";
import { 
  APPLICATION_MODE_NEW, 
  ROUTE_PATH
} from "../../../app/constants";
import { agencyApplicationSelector } from "../../../redux/selector/agencyApplicationSelector";
import { usePathApplication } from "../../../redux/hooks/usePathApplication";

export const RegulatoryInfoConfirmationView = (props) => {
  const dispatch = useDispatch();
  const { application } = usePathApplication();
  const isPrincipalBroker =  (ROUTE_PATH.PB_APP.search(application) !== -1);
  const [showRegulatoryInfoConfirmationError, setShowRegulatoryInfoConfirmationError] = useState(false);

  const {agencyApplication} = useSelector(agencyApplicationSelector) || {};
  const licencingSubType = agencyApplication?.licencingSubType;

  const title = "Have you completed the regulatory information program?";

  const handleNext = (confirmRole) => () => {
    setShowRegulatoryInfoConfirmationError(!confirmRole);

    if(confirmRole) {
      dispatch(push(`/${application}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_ROLE_CONFIRMATION}`));
      return;
    }
  };

  return (
    <div className="container">
      <TopNavigationBar 
          {...props}
          hideSaveAndExit 
          applicationType={applicationTypeFromLicenceSubType(licencingSubType)} 
          applicationMode={APPLICATION_MODE_NEW} 
      />
      {/* Title */}
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <h1>{title}</h1>
        </div>
      </div>

      {/* Yes/No Answer */}
      <div className="row">
        <div className="col-lg-2 ">
          <Button
            className={"ns-btn-yes-no btn-default"}
            buttonType="primary_regular"
            onClick={handleNext(true)}
            text={"Yes"}
          />
        </div>

        <div className="col-lg-3 has-error">
          <Button
            className={"ns-btn-yes-no btn-default"}
            buttonType="primary_regular"
            onClick={handleNext(false)}
            value={false}
            text={"No"}
          />
          {showRegulatoryInfoConfirmationError &&
            ErrorWithString(`The ${isPrincipalBroker ? 'Principal Broker' : 'Compliance Officer'} must be complete the regulatory information program.`)
          }
        </div>
      </div>
    </div>
  );
};
